// extracted by mini-css-extract-plugin
module.exports = {"hidden":"hidden--IFBE5U2H_KdjGPAxr1E_"};